import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router';

Vue.use(Vuex)
import { VerifyCaphe } from "../request/http"
export default new Vuex.Store({
  state: {
    flag: false,
    fileInfor: {},
    goPage: false
  },
  mutations: {
    setUserName (state, sys) {
      state.fileInfor = sys
    },
    changeFlag (state, statu) {
      // 变更状态
      state.flag = statu
    },
    goPage (state) {
      state.goPage = true
    }
  },
  actions: {
    // 获取用户相关信息
    VerifyCaphe ({ state, commit }, data) {
      VerifyCaphe(data.id, data.code).then(res => {
        console.log(res);
        if (res.code != 0) {
          commit('changeFlag', true)
        } else {

          commit('setUserName', res.data)
          router.push({ path: '/shareFile' })

        }
      })
    }
  },
  // modules: {
  //   user,
  //   userChange
  // }
})


// WEBPACK FOOTER //
// ./src/store/index.js